@if (helpForm()) {
<form [formGroup]="helpForm()" class="help-form">
  <div class="row g-3">
    <!-- Contenido (izquierda en desktop, abajo en móvil) -->
    <div class="col-12 col-md-8 order-2 order-md-1">
      <div class="panel p-3 help-content-panel">
        <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 class="mb-0">Contenido</h5>
          <div class="d-flex align-items-center flex-wrap gap-2">
            <div class="btn-group btn-group-sm" role="group" aria-label="Vista del contenido">
              <button type="button" class="btn"
                [class.btn-primary]="contentTab() === 'edit'"
                [class.btn-outline-secondary]="contentTab() !== 'edit'"
                (click)="contentTab.set('edit')">
                <i class="fas fa-pen me-1"></i> Editar
              </button>
              <button type="button" class="btn"
                [class.btn-primary]="contentTab() === 'preview'"
                [class.btn-outline-secondary]="contentTab() !== 'preview'"
                (click)="contentTab.set('preview')">
                <i class="fas fa-eye me-1"></i> Vista previa
              </button>
              <button type="button" class="btn"
                [class.btn-primary]="contentTab() === 'split'"
                [class.btn-outline-secondary]="contentTab() !== 'split'"
                (click)="contentTab.set('split')">
                <i class="fas fa-columns me-1"></i> Ambos
              </button>
              <button type="button" class="btn"
                [class.btn-primary]="contentTab() === 'captures'"
                [class.btn-outline-secondary]="contentTab() !== 'captures'"
                (click)="contentTab.set('captures')">
                <i class="fas fa-image me-1"></i> Capturas
              </button>
            </div>
            <ng-content select="[helpFormActions]"></ng-content>
          </div>
        </div>

        @if (contentTab() === 'edit') {
          <label class="form-label small text-muted">Markdown</label>
          <textarea class="form-control font-monospace help-body-editor" rows="22"
            formControlName="bodyMd"
            placeholder="## Para qué sirve..."></textarea>
        } @else if (contentTab() === 'preview') {
          <label class="form-label small text-muted">Vista previa</label>
          <div class="help-md-preview border rounded p-3 bg-light"
            [innerHTML]="previewHtml()"></div>
        } @else if (contentTab() === 'split') {
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label small text-muted">Markdown</label>
              <textarea class="form-control font-monospace help-body-editor help-body-editor--split" rows="18"
                formControlName="bodyMd"
                placeholder="## Para qué sirve..."></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label small text-muted">Vista previa</label>
              <div class="help-md-preview help-md-preview--split border rounded p-3 bg-light"
                [innerHTML]="previewHtml()"></div>
            </div>
          </div>
        }

        <div [hidden]="contentTab() !== 'captures'">
          <ng-content select="[helpAttachments]"></ng-content>
        </div>
      </div>
    </div>

    <!-- Metadatos (derecha en desktop, arriba en móvil) -->
    <div class="col-12 col-md-4 order-1 order-md-2">
      <div class="panel p-3 help-meta-panel">
        <h5 class="mb-3">Artículo</h5>

        <div class="mb-3">
          <label class="form-label">Ruta</label>
          <ng-select
            [items]="routeOptions()"
            bindLabel="label"
            bindValue="value"
            [addTag]="true"
            [clearable]="true"
            placeholder="Ej. solicitudes o vacío = general"
            formControlName="routePath">
          </ng-select>
          <div class="form-text small">
            Vacío = ayuda general (inicio). Debe coincidir con el path del menú / URL
            (ej. <code>solicitudes</code> = Bandeja de Entrada).
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Título</label>
          <input type="text" class="form-control" formControlName="title" placeholder="Título del artículo">
          @if (helpForm().get('title')?.errors?.['required'] && helpForm().get('title')?.touched) {
            <small class="text-danger">Título requerido</small>
          }
        </div>

        <div class="mb-3">
          <label class="form-label">Resumen</label>
          <textarea class="form-control" rows="3" formControlName="summary"
            placeholder="2–3 líneas para el panel de ayuda"></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label">Audiencia</label>
          <select class="form-select" formControlName="audience">
            @for (a of audiences; track a.value) {
              <option [ngValue]="a.value">{{ a.label }}</option>
            }
          </select>
          <div class="form-text small">
            Documentá en el markdown (Roles y acceso) qué puede hacer cada rol.
          </div>
        </div>

        <div class="mb-0">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="helpIsActive">
            <label class="form-check-label" for="helpIsActive">Activo / visible en el sistema</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
}
